module.exports = __webpack_public_path__ + "img/wb.59d7f0ea.png";